import React from "react";
import GlassCard from "./GlassCard";
import { aboutContent } from "../data/aboutContent";
import { useNavigate } from "react-router-dom";

const About = ({ lang = "sl" }) => {
  
  const t = aboutContent[lang];
  const navigate = useNavigate()
  const goTermsOfService = () => {
    navigate(`/${lang}/terms-of-service`)
  }
  const goAbout = () => {
    navigate(`/${lang}/about-us`);
  };
  return (
    <section id="about">
      <div className="container" style={{ maxWidth: 1040 }}>
        <GlassCard
          style={{
            padding: "40px 32px 32px",
            borderRadius: 32,
          }}
        >
          
          <h2
            style={{
              textAlign: "center",
              marginTop: 0,
              marginBottom: 12,
              color: "#176B87",
              fontSize: 28,
            }}
          >
            {t.title}
          </h2>
          <p
            style={{
              textAlign: "center",
              marginBottom: 32,
              color: "var(--text-muted)",
            }}
          >
            {t.description}
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1.1fr)",
              gap: 24,
            }}
          >
            <div>
              <h3 style={{ marginTop: 0, marginBottom: 8 }}>{t.subTitle1}</h3>
              <p style={{ marginTop: 0, color: "var(--text-muted)" }}>
                {t.description1} <div><button onClick={goTermsOfService} style={{color: "var(--text--muted)"}}>[Terms of service]</button></div>
              </p>

              <h3 style={{ marginTop: 24, marginBottom: 8 }}>{t.subTitle2}</h3>
              <p style={{ marginTop: 0, color: "var(--text-muted)" }}>
                {t.description2}
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 16,
              }}
            >
              <GlassCard
                style={{
                  padding: "18px 20px",
                  borderRadius: 18,
                  background: "rgba(255,255,255,0.65)",
                }}
              >
                <div style={{ fontSize: 28, fontWeight: 700, color: "#176B87" }}>
                  10+
                </div>
                <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
                  {t.yExperience}
                </div>
              </GlassCard>

              <GlassCard
                style={{
                  padding: "18px 20px",
                  borderRadius: 18,
                  background: "rgba(255,255,255,0.65)",
                }}
              >
                <div style={{ fontSize: 28, fontWeight: 700, color: "#176B87" }}>
                  24/7
                </div>
                <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
                  {t.availability}
                </div>
              </GlassCard>

              <GlassCard
                style={{
                  padding: "18px 20px",
                  borderRadius: 18,
                  background: "rgba(255,255,255,0.65)",
                }}
              >
                <div style={{ fontWeight: 600 }}>{t.cpSubTitle}</div>
                <p style={{ fontSize: 13, color: "var(--text-muted)" }}>
                  {t.cpText}
                </p>
              </GlassCard>

              <GlassCard
                style={{
                  padding: "18px 20px",
                  borderRadius: 18,
                  background: "rgba(255,255,255,0.65)",
                }}
              >
                <div style={{ fontWeight: 600 }}>{t.secPlatformTitle}</div>
                <p style={{ fontSize: 13, color: "var(--text-muted)" }}>
                  {t.secPlatformText}
                </p>
              </GlassCard>
            </div>
          </div>
        </GlassCard>
      </div>
    </section>
  );
};

export default About;
